<template>
  <div>
    <div class="widget-wrap" />
    <Header />
    <div class="background mozo wf-section">
      <div id="shop-frame" :data-url="url" style="max-width: 600px; margin: 0 auto"></div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/general/Header.vue"

export default {
  components: {
    Header,
  },

  data: () => {
    return {}
  },

  computed: {},

  async created() {},

  methods: {
    getParams(string, param) {
      const params = new Proxy(new URLSearchParams(string), {
        get: (searchParams, prop) => searchParams.get(prop),
      })
      return params[param]
    },
  },
}
</script>

<style defer scoped>
.button-div {
  justify-content: flex-end;
}
</style>
